import { ReactElement } from 'react'
import Heading from '../../Atoms/Heading'
import { IconHeadingBtnProps } from './props'
import { StyledIconHeadingBtn } from './styles'

const IconHeadingBtn = ({
    heading,
    subheadingOne,
    subheadingTwo,
    variant,
    active,
    onClick,
    icon,
}: IconHeadingBtnProps): ReactElement => {
    return (
        <StyledIconHeadingBtn
            variant={variant}
            active={active}
            onClick={onClick}
        >
            {icon}
            <Heading size={4}>{heading}</Heading>
            {subheadingOne} {subheadingTwo}
        </StyledIconHeadingBtn>
    )
}

export default IconHeadingBtn
export { StyledIconHeadingBtn }
